import { DataGrid as FoundationDataGrid, DataGridCell as FoundationDataGridCell, DataGridRow as FoundationDataGridRow, defaultDataGridConfig, defaultDataGridCellConfig, defaultDataGridRowConfig, foundationDataGridCellShadowOptions, foundationDataGridRowShadowOptions, foundationDataGridShadowOptions, } from '@genesislcap/foundation-ui';
import { dataGridCellTemplate, dataGridRowTemplate } from '@microsoft/fast-foundation'; // foundation?
import { zeroDataGridCellStyles as cellStyles } from './data-grid-cell.styles';
import { zeroDataGridRowStyles as rowStyles } from './data-grid-row.styles';
import { zeroDataGridStyles as gridStyles } from './data-grid.styles';
import { zeroDataGridTemplate as gridTemplate } from './data-grid.template';
/**
 * @tagname %%prefix%%-data-grid-cell
 */
export class DataGridCell extends FoundationDataGridCell {
}
/**
 * The Zero Data Grid Cell Element.
 *
 * @public
 * @remarks
 * HTML Element: \<zero-data-grid-cell\>
 */
export const zeroDataGridCell = DataGridCell.compose(Object.assign({ baseName: 'data-grid-cell', template: dataGridCellTemplate, styles: cellStyles, shadowOptions: foundationDataGridCellShadowOptions }, defaultDataGridCellConfig));
/**
 * @tagname %%prefix%%-data-grid-row
 */
export class DataGridRow extends FoundationDataGridRow {
}
/**
 * The Zero Data Grid Row Element.
 *
 * @public
 * @remarks
 * HTML Element: \<zero-data-grid-row\>
 */
export const zeroDataGridRow = DataGridRow.compose(Object.assign({ baseName: 'data-grid-row', template: dataGridRowTemplate, styles: rowStyles, shadowOptions: foundationDataGridRowShadowOptions }, defaultDataGridRowConfig));
/**
 * @tagname %%prefix%%-data-grid
 */
export class DataGrid extends FoundationDataGrid {
}
/**
 * The Zero Data Grid Element.
 *
 * @public
 * @remarks
 * HTML Element: \<zero-data-grid\>
 */
export const zeroDataGrid = DataGrid.compose(Object.assign({ baseName: 'data-grid', template: gridTemplate, styles: gridStyles, shadowOptions: foundationDataGridShadowOptions }, defaultDataGridConfig));
